module.exports = __webpack_public_path__ + "static/media/branding-img13.215ec099.jpg";